module.exports = __webpack_public_path__ + "static/media/001.29a64af4.jpeg";